
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18 8.99997C17.44 8.99997 17 9.44997 17 9.99997V15.59L6.11998 4.69997C5.72998 4.30997 5.09998 4.30997 4.70998 4.69997C4.31998 5.08997 4.31998 5.71997 4.70998 6.10997L15.59 17H9.99998C9.44998 17 8.99998 17.45 8.99998 18C8.99998 18.55 9.44998 19 9.99998 19H18C18.55 19 19 18.55 19 18V9.99997C19 9.44997 18.55 8.99997 18 8.99997Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-south-east`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSouthEast

    ```js
    <b-new-b-icon-south-east />
    ```
</docs>


